var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#8C8C8C",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.38281 7.36719H5.60938L5.53906 3.34375H6.45312L6.38281 7.36719ZM6 9.05469C5.90104 9.05469 5.80729 9.02995 5.71875 8.98047C5.63281 8.93099 5.5651 8.86328 5.51562 8.77734C5.46615 8.69141 5.44271 8.59896 5.44531 8.5C5.44271 8.40104 5.46615 8.30859 5.51562 8.22266C5.5651 8.13672 5.63281 8.06901 5.71875 8.01953C5.80729 7.97005 5.90104 7.94531 6 7.94531C6.09635 7.94531 6.1875 7.97005 6.27344 8.01953C6.35938 8.06901 6.42708 8.13672 6.47656 8.22266C6.52865 8.30859 6.55469 8.40104 6.55469 8.5C6.55469 8.59896 6.52865 8.69141 6.47656 8.77734C6.42708 8.86328 6.35938 8.93099 6.27344 8.98047C6.1875 9.02995 6.09635 9.05469 6 9.05469Z",
    fill: "#8C8C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.a7225181ef6e30e107431656a1eb4fae.svg";
export { ForwardRef as ReactComponent };